import styles from "@styles/components/link/index.module.scss";
import Link from "next/link";
import React, {MouseEvent} from "react";

export interface LinkProps {
    children?: React.ReactNode;
    props?: any;
    classes?: string;
    href: string;
    onClick?: | ((event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void) | undefined;
}

const SILink: React.FC<LinkProps> = ({children, onClick = (e: React.MouseEvent<HTMLAnchorElement>) => {}, ...props}) => {
    const handleOnClick = (e: MouseEvent<HTMLAnchorElement>) => {
        // @ts-ignore
        onClick(e);
    };

    return (
        <Link className={`${styles.link} ${props.classes ? props.classes : ''}`} {...props} onClick={handleOnClick}>
            {children}
        </Link>
    );
};
export default SILink;
